import { create } from "@bufbuild/protobuf";
import { useQuery } from "@tanstack/react-query";
import { journalServiceClient } from "@/connect";
import type { GetSelfContractsRequest } from "@/types/proto/api/v1/memo_service_pb";
import { GetSelfContractsRequestSchema } from "@/types/proto/api/v1/memo_service_pb";

// Query keys factory for consistent cache management
export const selfContractKeys = {
  all: ["self-contracts"] as const,
  lists: () => [...selfContractKeys.all, "list"] as const,
  list: (filters: Partial<GetSelfContractsRequest>) => [...selfContractKeys.lists(), filters] as const,
};

/**
 * Hook to fetch self-contracts for the current user
 * @param request - Optional filters for the list request (ticker, status, template, page_size, page_token)
 */
export function useSelfContracts(request: Partial<GetSelfContractsRequest> = {}) {
  return useQuery({
    queryKey: selfContractKeys.list(request),
    queryFn: async () => {
      const response = await journalServiceClient.getSelfContracts(
        create(GetSelfContractsRequestSchema, request as Record<string, unknown>),
      );
      return response;
    },
    staleTime: 1000 * 60 * 2, // 2 minutes - self-contracts can change when user edits memos
    gcTime: 1000 * 60 * 5, // Keep unused data in cache for 5 minutes
  });
}
